import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600Scatterplot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M342.5,331.67H166.17v-172c0-4.78-3.88-8.66-8.66-8.66c-4.78,0-8.66,3.88-8.66,8.66v180.66 c0,4.78,3.88,8.66,8.66,8.66H342.5c4.78,0,8.66-3.88,8.66-8.66C351.16,335.55,347.28,331.67,342.5,331.67z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st0",
			cx: 333.22,
			cy: 212.22,
			r: 17.94
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -137.3483 370.0068)",
			className: "st0",
			cx: 208.2,
			cy: 287.78,
			rx: 17.94,
			ry: 17.94
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st0",
			cx: 243.01,
			cy: 237.26,
			r: 17.94
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st0",
			cx: 298.41,
			cy: 262.74,
			r: 17.94
		})
	] })]
});
const ForwardRef = forwardRef(SvgN600Scatterplot);
export { ForwardRef as ReactComponent };
